exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.parent[data-v-0d025f02] {\n    text-align: center;\n}\n.example[data-v-0d025f02] {\n    display: inline-block;\n}\n/*PC PAD用css*/\n@media screen and (min-width: 991px) {\n.footer-menu[data-v-0d025f02] {\n        margin-top: auto;\n}\n}\n@media screen and (max-width: 991px) {\n.footer-menu[data-v-0d025f02] {\n        margin-top: auto;\n        width: none;\n        margin: auto;\n}\n.parent[data-v-0d025f02] {\n        text-align: initial;\n}\n}\n", ""]);

// exports
